import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import Step9View from './Step9-view';
import {checkRequiredValues} from "../../utils/forms/checkRequiredValues";
import {getFileFromDataURI} from "../../utils/files/getFileFromDataURI";
import {fileTypesIds} from "../../constants/fileTypeIds";
import {checkNextStepAndGo} from '../../utils/checkNextStepAndGo';
import {useIntl} from "react-intl";
import {trackEvent} from "../../utils/trackEvent";

const Step9 = ({
                 submitStep,
                 uploadFile,
                 regType,
                 prevCompletedStepSign,
                 prevCompletedStepSignFalse,
               }) => {
  const initialValues = {
    signature: null,
  };

  const validate = values => {
    let errors = {};
    errors = checkRequiredValues(values, errors);

    return errors;
  };

  const handleSubmit = (values) => {
    handleSave(values)()
  };

  const {formatMessage} = useIntl();

  const handleSave = values => () => {
    getFileFromDataURI({dataURI: values.signature, filename: 'signature-form6101.png'})
      .then(file => uploadFile({
        file,
        fileTypeId: fileTypesIds.step9.signature
      }))
      .then(() => submitStep({
        step: 9,
        data: {regType, prevCompletedStepSign},
      }))
      .then(checkNextStepAndGo)
      .then(() => prevCompletedStepSignFalse())
      .then(() => trackEvent('signup_step',
          {
            step_number: 9,
            step_name_en: 'National insurance',
            step_name_he: formatMessage({id: 'step9.page.title', defaultMessage: ''}),
            regType
          }
        )
      )
      .catch(err => console.log({err}));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {({isValid, submitCount}) => (
        <Step9View
          isValid={isValid || submitCount === 0}
        />
      )}
    </Formik>
  )
};

Step9.propTypes = {
  regType: PropTypes.string,
  submitStep: PropTypes.func,
  uploadFile: PropTypes.func
};

export default Step9;
